import { useEffect } from "react";

import { useRouter } from "next/router";

interface RedirectProps {
  path: string;
}

export function Redirect({ path }: RedirectProps) {
  const router = useRouter();

  useEffect(() => {
    // Prevent navigation to the same URL to avoid invariant violation
    if (router.asPath !== path) {
      void router.replace(path);
    }
  }, [router, path]);

  return null;
}
